// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"7cf073fc","455":"db57dacf"}[chunkId] + ".chunk.js";
};